import React from "react";

import Typewriter from "typewriter-effect";

export const Type = () => {
  return (
    <>
      <Typewriter
        options={{
          strings: [
            "Angular Developer",
            "React Developer",
            "TypeScript Developer",
            "Frontend Developer in India",
            "Music Enthusiast",
          ],
          autoStart: true,
          loop: true,
          deleteSpeed: 40,
        }}
      />
    </>
  );
};
